(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-wrapper"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', initPinnedArticles);
  document.addEventListener('shopify:section:load', initPinnedArticles);

  function initPinnedArticles() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    document.querySelectorAll('[data-featured-articles]').forEach(section => {
      if (section.dataset.init) return;
      section.dataset.init = 'true';

      const slides = section.querySelectorAll('.article-slide');
      const counterGroups = section.querySelectorAll('.featured-post-count');
      const slidesCount = slides.length;
      const SCROLL_STEP = 500;
      let activeIndex = 0;

      function animateSlideIn(slide) {
        const image = slide.querySelector('.image-wrap');
        const title = slide.querySelector('.article-title');
        const excerpt = slide.querySelector('.article-excerpt');
        const button = slide.querySelector('.btn-wrapper');
        const counter = slide.querySelector('.featured-post-count');

        const parts = [image, title, excerpt, button, counter].filter(Boolean);

        gsap.killTweensOf(parts);

        gsap.set(parts, { clearProps: 'all' });
        gsap.set(image, { opacity: 0, x: 40, scale: 0.96 });
        gsap.set([title, excerpt, button], { opacity: 0, y: 24 });
        gsap.set(counter, { opacity: 0, x: 16 });

        gsap.timeline()
          .to(image, {
            opacity: 1,
            x: 0,
            scale: 1,
            duration: 0.8,
            ease: 'power3.out'
          })
          .to([title, excerpt, button], {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: 'power3.out',
            stagger: 0.12
          }, '-=0.45')
          .to(counter, {
            opacity: 1,
            x: 0,
            duration: 0.45,
            ease: 'power2.out'
          }, '-=0.45');
      }

      function animateSlideOut(slide) {
        const image = slide.querySelector('.image-wrap');
        const title = slide.querySelector('.article-title');
        const excerpt = slide.querySelector('.article-excerpt');
        const button = slide.querySelector('.btn-wrapper');
        const counter = slide.querySelector('.featured-post-count');

        const parts = [image, title, excerpt, button, counter].filter(Boolean);

        gsap.killTweensOf(parts);

        gsap.to(parts, {
          opacity: 0,
          y: 10,
          duration: 0.2,
          ease: 'power1.out',
          overwrite: true
        });
      }

      function activateSlide(index, forceAnimate = false) {
        if (index === activeIndex && !forceAnimate) return;

        slides.forEach((slide, i) => {
          const isActive = i === index;

          if (slide.classList.contains('is-active') && !isActive) {
            animateSlideOut(slide);
          }

          slide.classList.toggle('is-active', isActive);
        });

        counterGroups.forEach(group => {
          const buttons = group.querySelectorAll('.counter-item');
          buttons.forEach((btn, i) => {
            btn.classList.toggle('active-counter', i === index);
          });
        });

        const activeSlide = slides[index];
        if (activeSlide) {
          animateSlideIn(activeSlide);
        }

        activeIndex = index;
      }

      counterGroups.forEach(group => {
        group.querySelectorAll('.counter-item').forEach(btn => {
          btn.addEventListener('click', () => {
            activateSlide(+btn.dataset.index, true);
          });
        });
      });

      ScrollTrigger.create({
        trigger: section,
        start: 'top top',
        end: `+=${slidesCount * SCROLL_STEP}`,
        pin: true,
        scrub: true,
        onEnter: () => {
          activateSlide(0, true);
        },
        onUpdate(self) {
          const index = Math.round(self.progress * (slidesCount - 1));
          if (index !== activeIndex) {
            activateSlide(index);
          }
        }
      });

      activateSlide(0, true);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["editorial-depth-stack"] && !Shopify.designMode) return;
  try {
    
(function () {
  const SECTION_SELECTOR = '[data-editorial-depth-stack]';

  function killSectionTriggers(section) {
    ScrollTrigger.getAll().forEach((trigger) => {
      if (trigger.vars && trigger.vars.trigger && section.contains(trigger.vars.trigger)) {
        trigger.kill();
      }
    });
  }

  function initEditorialDepthStack(section) {
    if (!section) return;
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

    gsap.registerPlugin(ScrollTrigger);

    if (section._editorialDepthStackMatchMedia) {
      section._editorialDepthStackMatchMedia.revert();
    }

    killSectionTriggers(section);

    const desktopBreakpoint = parseInt(section.dataset.desktopBreakpoint || '991', 10);
    const enablePin = section.dataset.enablePin === 'true';
    const enableParallax = section.dataset.enableParallax === 'true';

    const content = section.querySelector('[data-editorial-content]');
    const splitItems = section.querySelectorAll('[data-split-reveal]');
    const fadeItems = section.querySelectorAll('[data-fade-reveal]');
    const depthCards = section.querySelectorAll('[data-depth-card]');
    const mediaInners = section.querySelectorAll('[data-depth-media-inner]');

    const mm = gsap.matchMedia();
    section._editorialDepthStackMatchMedia = mm;

    mm.add(`(min-width: ${desktopBreakpoint + 1}px)`, () => {
      gsap.set(splitItems, { autoAlpha: 0, y: 28 });
      gsap.set(fadeItems, { autoAlpha: 0, y: 24 });

      depthCards.forEach((card, index) => {
        const initialRotate = index === 1 ? 2 : index === 2 ? -2 : 0;
        gsap.set(card, {
          autoAlpha: 0,
          y: 40,
          x: 0,
          rotate: initialRotate,
          scale: 0.96
        });
      });

      gsap.set(mediaInners, { yPercent: 0, force3D: true });

      const introTimeline = gsap.timeline({
        scrollTrigger: {
          trigger: section,
          start: 'top 75%',
          once: true
        }
      });

      introTimeline.to(splitItems, {
        autoAlpha: 1,
        y: 0,
        duration: 0.7,
        stagger: 0.08,
        ease: 'power3.out'
      });

      introTimeline.to(fadeItems, {
        autoAlpha: 1,
        y: 0,
        duration: 0.65,
        stagger: 0.08,
        ease: 'power3.out'
      }, '-=0.35');

      introTimeline.to(depthCards, {
        autoAlpha: 1,
        y: 0,
        scale: 1,
        duration: 0.8,
        stagger: 0.1,
        ease: 'power3.out'
      }, '-=0.4');

      if (enablePin && content) {
        ScrollTrigger.create({
          trigger: section,
          start: 'top top+=8%',
          end: 'bottom bottom-=8%',
          pin: content,
          pinSpacing: false,
          anticipatePin: 1
        });
      }

      depthCards.forEach((card, index) => {
        const strength = parseInt(card.dataset.depth || '40', 10);

        let fromY = 0;
        let toY = 0;
        let fromX = 0;
        let toX = 0;
        let fromRotate = 0;
        let toRotate = 0;

        if (index === 0) {
          fromY = 0;
          toY = -18;
          fromX = 0;
          toX = -8;
          fromRotate = 0;
          toRotate = -1;
        }

        if (index === 1) {
          fromY = strength * 0.35;
          toY = strength * -0.95;
          fromX = 18;
          toX = -26;
          fromRotate = 2;
          toRotate = -2.5;
        }

        if (index === 2) {
          fromY = strength * 0.55;
          toY = strength * -1.15;
          fromX = -12;
          toX = 18;
          fromRotate = -2;
          toRotate = 2.25;
        }

        gsap.fromTo(card,
          {
            y: fromY,
            x: fromX,
            rotate: fromRotate
          },
          {
            y: toY,
            x: toX,
            rotate: toRotate,
            ease: 'none',
            scrollTrigger: {
              trigger: section,
              start: 'top bottom-=5%',
              end: 'bottom top+=5%',
              scrub: 1.15
            }
          }
        );
      });

      if (enableParallax) {
        mediaInners.forEach((inner, index) => {
          let fromY = -2;
          let toY = 6;

          if (index === 1) {
            fromY = -6;
            toY = 8;
          }

          if (index === 2) {
            fromY = -8;
            toY = 10;
          }

          gsap.fromTo(inner,
            { yPercent: fromY },
            {
              yPercent: toY,
              ease: 'none',
              scrollTrigger: {
                trigger: section,
                start: 'top bottom',
                end: 'bottom top',
                scrub: 1.2
              }
            }
          );
        });
      }

      ScrollTrigger.refresh();
    });

    mm.add(`(max-width: ${desktopBreakpoint}px)`, () => {
      gsap.set([...splitItems, ...fadeItems, ...depthCards], {
        autoAlpha: 1,
        clearProps: 'transform'
      });

      gsap.set(mediaInners, {
        clearProps: 'all'
      });

      splitItems.forEach((item, index) => {
        gsap.fromTo(item,
          { autoAlpha: 0, y: 18 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.55,
            ease: 'power2.out',
            delay: index * 0.04,
            scrollTrigger: {
              trigger: item,
              start: 'top 92%',
              once: true
            }
          }
        );
      });

      fadeItems.forEach((item) => {
        gsap.fromTo(item,
          { autoAlpha: 0, y: 16 },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.5,
            ease: 'power2.out',
            scrollTrigger: {
              trigger: item,
              start: 'top 92%',
              once: true
            }
          }
        );
      });

      depthCards.forEach((card, index) => {
        gsap.fromTo(card,
          {
            autoAlpha: 0,
            y: 24
          },
          {
            autoAlpha: 1,
            y: 0,
            duration: 0.6,
            ease: 'power2.out',
            delay: index * 0.06,
            scrollTrigger: {
              trigger: card,
              start: 'top 92%',
              once: true
            }
          }
        );
      });

      ScrollTrigger.refresh();
    });
  }

  function initAllEditorialDepthStacks(scope) {
    const root = scope || document;
    const sections = root.querySelectorAll(SECTION_SELECTOR);
    sections.forEach(initEditorialDepthStack);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllEditorialDepthStacks(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllEditorialDepthStacks(event.target);
  });

  document.addEventListener('shopify:section:reorder', function () {
    initAllEditorialDepthStacks(document);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
